import type { SearchParams } from '$lib/services/urls/searchParams';
import type { PoiFilters } from '../types';
import { PoiFilterId } from '$houdini';
import { usePersistentState } from '$lib/utils/persistentState.svelte';

const STORAGE_KEY = 'poi-filters';
const AUTHORIZED_FILTERS = [PoiFilterId.GAS_STATION_TYPE, PoiFilterId.CONNECTOR, PoiFilterId.POWER, PoiFilterId.GAS_STATION_LAST_UPDATE, PoiFilterId.GAS_STATION_EQUIPMENT, PoiFilterId.GAS_STATION_NETWORK];

export const poiCategoriesToPersist = ['EV_SERVICE', 'SERVICE_GAS_STATION'] as const;

type PersistedPoiFilters = SearchParams['filters'];

export function usePersistPoiFilters() {
	const persistedPoiFilters = usePersistentState<PersistedPoiFilters>(STORAGE_KEY, {}, { storageType: 'session' });

	return {
		setPoiFiltersInStore: (poiFilters: PoiFilters) => {
			const filteredPoiFilters = Object.fromEntries(
				Object.entries(poiFilters).filter(([key]) => AUTHORIZED_FILTERS.includes(key as (typeof AUTHORIZED_FILTERS)[number])),
			);

			if (Object.keys(filteredPoiFilters).length > 0) {
				persistedPoiFilters.setCurrent(filteredPoiFilters as PersistedPoiFilters);
			}
		},
		getStoredPoiFilters: () => {
			return $state.snapshot(persistedPoiFilters.getCurrent());
		},
	};
}
